import type { SVGProps } from 'react';

import { SvgStroke } from '@xemplo/style-constants';
const DawnChartGraph = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={props.strokeWidth ?? SvgStroke.Regular}
      d="M8.625 10.875V16.5M12 13.125V16.5m3.375-7.875V16.5M6.895 21h10.21A3.895 3.895 0 0 0 21 17.105V6.895A3.895 3.895 0 0 0 17.105 3H6.895A3.895 3.895 0 0 0 3 6.895v10.21A3.895 3.895 0 0 0 6.895 21Z"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
export default DawnChartGraph;
